<!--
 * @Author: lan.h
 * @Date: 2022-02-21 14:39:42
 * @LastEditors: lan.h
 * @LastEditTime: 2022-03-28 11:10:17
 * @Description: 国内外融资
-->
<template>
  <div>
    <div :class="showMore ? 'mode-title' : 'mode-title2'">
      <div>
        <span :class="{'title-p': event_domestic == 1}" @click="handleChangeDomestic(1)">国内融资</span>
        <span :class="{'title-p': event_domestic == 0}" @click="handleChangeDomestic(0)">国外融资</span>
      </div>
    </div>
    <div class="financing" :class="showMore ? '' : 'financing2'">
      <p class="financing-info">
        <span class="left">本周融资：</span><span class="num">{{week_count}}</span>
        <span class="left">金额：</span><span class="num">{{week_amount}}亿人民币</span>
      </p>
      <div class="financing-chart" id="financing-chart"></div>
    </div>
    <div class="recent" v-if="showMore">
      <div class="recent-item">
        <div>投融资</div>
        <div>{{total.t_event}}</div>
        <a  class="more" href="https://vbdata.cn/eventList" target="_blank" 
            onclick="_czc.push(['_trackEvent', '首页(新)', '右侧融资图栏目(投融资立即查看)', '点击量'])">立即查看</a>
      </div>
      <div class="recent-item">
        <div>项目库</div>
        <div>{{total.t_comp}}</div>
        <a  class="more" href="https://vbdata.cn/companyList" target="_blank" 
            onclick="_czc.push(['_trackEvent', '首页(新)', '右侧融资图栏目(项目库立即查看)', '点击量'])">立即查看</a>
      </div>
      <div class="recent-item">
        <div>投资机构</div>
        <div>{{total.t_org}}</div>
        <a  class="more" href="https://vbdata.cn/orgList" target="_blank"
            onclick="_czc.push(['_trackEvent', '首页(新)', '右侧融资图栏目(投资机构立即查看)', '点击量'])">立即查看</a>
      </div>
      <div class="recent-item">
        <div>研究报告</div>
        <div>{{total.t_req}}</div>
        <a  class="more" href="https://vbdata.cn/reportList" target="_blank"
            onclick="_czc.push(['_trackEvent', '首页(新)', '右侧融资图栏目(研究报告立即查看)', '点击量'])">立即查看</a>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import filter from "js/filter";
import echarts from "echarts";
import { getWeekEvent } from "../../service";
export default {
  props: {
    showMore: {
      default: true
    },
    pageType: {
      default: ''    //1首页  2找公司
    }
  },
  data() {
    return {
      event_domestic: 1,
      week_count: "",
      week_amount: "",
      dataChart: "",
      total: {},
      filter: filter,
      chart_option: {
        tooltip: {
          trigger: "axis",
          backgroundColor: "#404040",
          padding: 12,
          formatter: function(params, ticket, callback) {
            var time = params[0].name,
              title = `<p class="p1">` + time + `</p>`,
              e_html =
                `<p class="p2"><i class="cir_i" style="background: linear-gradient(90deg,` +
                params[0].color +
                ` 0%, ` +
                params[0].color +
                ` 100%)"></i>事件数：<span>` +
                params[0].value +
                `起</span></p>`,
              r_html =
                `<p class="p2"><i class="cir_i" style="background: linear-gradient(90deg,` +
                params[1].color +
                ` 0%, ` +
                params[1].color +
                ` 100%)"></i>金额：<span>` +
                params[1].value +
                `亿人民币</span></p>`;

            return (
              `<div class="chart_tip">` + title + e_html + r_html + `</div>`
            );
          }
        },
        grid: {
          left: "6px",
          right: "6px",
          top: "60px",
          bottom: "0",
          containLabel: true
        },
        legend: {
          data: ["数量", "金额"],
          selectedMode: false,
          top: "0",
          left: "0",
          itemWidth: 10,
          itemHeight: 10,
          icon: "rect",
          textStyle: {
            color: "#333",
            fontSize: 12,
            lineHeight: 12
          }
        },
        xAxis: [
          {
            type: "category",
            data: [],
            boundaryGap: false,
            axisPointer: {
              type: "line",
              lineStyle: {
                color: "rgba(0,0,0,.15)"
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: "'#666'"
              }
            },
            axisLabel: {
              formatter: a => {
                return moment(a).format("MM-DD");
              },
              textStyle: {
                color: "#999"
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "数量",
            scale: true,
            splitNumber: 3,
            axisLabel: {
              formatter: "{value}",
              color: "#999"
            },
            splitLine: {
              lineStyle: {
                color: "#f5f5f5",
                width: 1,
                type: "dashed"
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#999"
              }
            },
            axisTick: {
              show: false
            },
            minInterval: 1
          },
          {
            type: "value",
            name: "金额(亿)",
            scale: true,
            splitNumber: 3,
            axisLabel: {
              formatter: "{value}",
              color: "#999"
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#999"
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: "数量",
            type: "line",
            smooth: true,
            itemStyle: {
              normal: {
                color: 'rgb(108,169,255)',
                opacity: 0.7
              }
            },
            lineStyle: {
              normal: {
                width: 1
              }
            },
            areaStyle: {
              normal: {
                opacity: 0.9
              }
            },
            data: []
          },
          {
            name: "金额",
            type: "line",
            yAxisIndex: 1,
            smooth: true,
            itemStyle: {
              normal: {
                color: 'rgba(209,229,255)'
              }
            },
            lineStyle: {
              normal: {
                width: 1
              }
            },
            areaStyle: {
              normal: {
                opacity: 0.9
              }
            },
            data: []
          }
        ]
      }
    }
  },
  created() {
    this.getWeekEvent();
  },
  methods: {
    async getWeekEvent() {
      let res = await getWeekEvent({
        domestic: this.event_domestic
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.total = res.total
        let date_arr = [], count_arr = [], amount_arr = []
        let week_day = moment().day() == 0 ? moment().subtract(1, 'w').day(1) : moment().day(1)
        let i = 0
        while (i < 6){
          date_arr.push(moment(week_day).day(1 - 7*i).format('YYYY-MM-DD'))
          i++
        }
        date_arr.sort();
        date_arr.map((a, i) => {
          let index = res.res.findIndex(b => a == b.x_date);
          if (index > -1) {
            count_arr.push(res.res[index].event_count - 0);
            amount_arr.push(
              filter.amountChangeAveRate(
                res.res[index].event_amount,
                1,
                1,
                moment(a).year(),
                moment(a).year()
              )
            );
            if (i == 5) {
              this.week_count = res.res[index].event_count;
              this.week_amount = filter.amountChangeAveRate(
                res.res[index].event_amount,
                1,
                1,
                moment(a).year(),
                moment(a).year()
              );
            }
          } else {
            count_arr.push(0);
            amount_arr.push(0);
            if (i == 5) {
              this.week_count = 0;
              this.week_amount = 0;
            }
          }
        });
        this.chart_option.xAxis[0].data = date_arr;
        this.chart_option.series[0].data = count_arr;
        this.chart_option.series[1].data = amount_arr;

        this.dataChart = echarts.init(
          document.getElementById("financing-chart")
        );
        this.dataChart.setOption(this.chart_option);
      } else {
        this.$Message.error(res.message);
      }
    },
    handleChangeDomestic(idx) {
      this.event_domestic = idx;
      this.getWeekEvent();
      if(this.pageType == '1'){
        let type = idx == 1 ? '右侧融资图栏目(切换国内融资)' : '右侧融资图栏目(切换国外融资)'
        _czc.push(['_trackEvent', '首页(新)', type, '点击量'])
      }
      else if(this.pageType == '2'){
        let type = idx == 1 ? '热点观察(融资折线图_国内融资)' : '热点观察(融资热点图_国外融资)'
        _czc.push(['_trackEvent', '找公司(新)', type, '点击量'])
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.mode-title
  >div
    display: flex;
  span 
    font-size 20px
    font-weight 500
    color #666666
    margin-right 20px
    cursor pointer
    line-height 1
  .title-p
    color #333
.mode-title2
  >div
    display flex
  span
    font-size 16px
    font-weight 500
    color #666666
    margin-right 20px
    cursor pointer
    line-height 1
  .title-p
    color #333
.financing
  margin-top 16px
  z-index 3
  background #FFFFFF
  &-info
    span
      font-size 12px
      line-height 14px
      color #333
      display inline-block
      vertical-align top
      font-weight 500
    .num
      color #FA5A00
      margin-right 18px
    .num:last-child
      margin-right 0
  &-chart
    margin-top 8px
    height 190px
  >>> .chart_tip
    line-height 1
    p+p
      margin-top 8px
    .p1
      color #fff
      font-size 12px
    .p2
      font-size 12px
      color #C8C8C8
      span
        color #fff
      .cir_i
        display inline-block
        width 8px
        height 8px
        vertical-align top
        margin-top 2px
        border-radius 50%
        margin-right 6px
.financing2 
  padding 10px 20px 10px 10px
  .financing-chart
    height 150px
.recent
  display flex 
  justify-content space-between
  margin-top 15px
  &-item
    background #FFFAF6
    text-align center
    font-weight 500
    padding 10px
    >div:nth-child(1)
      font-size 12px
      color #999999
      line-height 1
    >div:nth-child(2)
      font-size 18px
      color #FA5A00
      line-height 1
      line-height 1
      margin 9px 0
    .more
      width 60px
      height 20px
      background #FA5A00
      border-radius 10px
      text-align center
      line-height 20px
      display block
      color #fff
      font-size 12px
      &:hover
        background #FF4800
        transition all 0.5s
</style>